import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'
import users from './users'
import settings from './settings'
import communicationlogs from './communicationlogs'
import templates from './templates'
import apitokens from './apitokens'
import smsresponselogs from './smsresponselogs'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'DEBTIA_HOME',
        breadcrumb: [
          {
            text: 'DEBTIA_HOME',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
        resource: 'MyRule',
        action: 'rule',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        resource: 'Auth',
        action: 'read',
      },
    },
    ...users,
    ...settings,
    ...communicationlogs,
    ...templates,
    ...apitokens,
    ...smsresponselogs,
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  // Redirect if logged in
  if (to.name === 'translations') {
    // eslint-disable-next-line no-param-reassign
    to.meta.navActiveLink = to.params.lang
  }
  return next()
})

export default router
